import { render, staticRenderFns } from "./SignOrDetailDialog.vue?vue&type=template&id=20a5a79e&scoped=true"
import script from "./SignOrDetailDialog.vue?vue&type=script&lang=js"
export * from "./SignOrDetailDialog.vue?vue&type=script&lang=js"
import style1 from "./SignOrDetailDialog.vue?vue&type=style&index=1&id=20a5a79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5a79e",
  null
  
)

export default component.exports